import React, { FC } from 'react';
import Modal from "../../../ui/Modal";
import {Button} from "../../../ui";
import {useDispatch} from "react-redux";
import {hideModal} from "../../../store/Modal/Modal.action";

type PropsType = {
  className?: string;
  isVisible: boolean;
  onConfirm?: () => void;
};

const WidgetModalObjectDelete: FC<PropsType> = ({ className, isVisible, onConfirm }) => {

  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(hideModal());
  };

  const handleConfirm = () => {
    onConfirm?.();
    handleClose();
  };

  return (
    <Modal
      className={`modal-delete-user ${className || ''}`}
      isVisible={isVisible}
      isClose
      isCloseBg
      title="Delete object?"
    >
      <div className="modal-delete-user__content">
        <p>Are you sure you want to delete the object? All the inner zones and sensors will be deleted as well. This action cannot be undone.</p>
      </div>
      <div className="modal-delete-user__action">
        <Button size="large" type="button" variant="secondary" onClick={handleClose}>
          Cancel
        </Button>

        <Button size="large" type="button" onClick={handleConfirm}>
          Delete
        </Button>
      </div>
    </Modal>
  );
};

export default WidgetModalObjectDelete;
